export enum FlyMenuEnum {
  Edit = "EDIT",
  Delete = "DELETE",
}
